import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface Announcement {
  id: string;
  title: string;
  message: string;
  author: string | null;
  published_at: string;
}

export function useAnnouncements() {
  return useQuery({
    queryKey: ["announcements"],
    queryFn: async (): Promise<Announcement[]> => {
      const now = new Date().toISOString();
      const { data, error } = await supabase
        .from("announcements")
        .select("id, title, message, author, published_at")
        .eq("is_active", true)
        .or(`expires_at.is.null,expires_at.gt.${now}`)
        .order("published_at", { ascending: false })
        .limit(10);
      if (error) throw error;
      return data ?? [];
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
